import * as cookies from 'js-cookie'
import { COOKIES_AUTHORIZATION_TOKEN } from '@App/constantes'

export const POST = 'post'
export const GET = 'get'
export const PUT = 'put'
export const DELETE = 'delete'

export const CONSOLE_API_URL = process.env.CONSOLE_API_URL || 'https://management.api.bliink.io'
export const CONSOLE_URL = process.env.CONSOLE_URL || 'https://manage.bliink.io'
export const ANALYZER_WEB_APP = process.env.ANALYZER_WEB_APP || 'https://analyzer.bliink.io'
export const API_URL = process.env.API_URL || 'https://connect.api.bliink.io'
export const MANAGEMENT_API = `${CONSOLE_API_URL}/v1`

export const UNSECURE_CONFIG = (method: string) => ({
  method,
})

export const AUTHORIZATION_CONFIG = (method: string, userAuthorizationData: any) => Object.assign(
  {},
  UNSECURE_CONFIG(method),
  {
    body: JSON.stringify(userAuthorizationData),
    headers: {
      'Content-Type': 'application/json',
    },
  },
)

export const SECURE_CONFIG = (method: string) => Object.assign(
  {},
  UNSECURE_CONFIG(method),
  {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${cookies.get(COOKIES_AUTHORIZATION_TOKEN)}`,
    },
  },
)

export const SECURE_CONFIG_URLENCODED_FORM = (method: string) => Object.assign(
  {},
  UNSECURE_CONFIG(method),
  {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${cookies.get(COOKIES_AUTHORIZATION_TOKEN)}`,
    },
  },
)

export const SECURE_CONFIG_FORM = (method: string) => Object.assign(
  {},
  UNSECURE_CONFIG(method),
  {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${cookies.get(COOKIES_AUTHORIZATION_TOKEN)}`,
    },
  },
)
